export default __webpack_public_path__ + "static/media/classified2.bc3b54da.JPG";